import axios from '@/utils/axios'
// 组件列表
export function listBook(query) {
    return axios({
        url: '/booklist/getBookListByAppId',
        method: 'get',
        params: query
    })
}
export function listBookDy(query) {
    return axios({
        url: '/booklist/getBookList',
        method: 'get',
        params: query
    })
}